import React from "react";
import axios from "axios";
import { HOST } from "../host-config";
import { getRequestHeaders } from "../GlobalFunctions/RequestHeaders.js";

export const getFaqs = async () => {
  const config = await getRequestHeaders();
  return axios.get(HOST + "/faqs/", config);
};
